export const FURNITURE_STATUS = {
  UNFURNISHED: 0,
  FURNISHED: 1,
  SEMI_FURNISHED: 2,
} as const;

export type FurnitureStatus =
  (typeof FURNITURE_STATUS)[keyof typeof FURNITURE_STATUS];

export const FURNITURE_STATUS_VALUES: FurnitureStatus[] = [
  FURNITURE_STATUS.UNFURNISHED,
  FURNITURE_STATUS.FURNISHED,
  FURNITURE_STATUS.SEMI_FURNISHED,
];

export const FURNITURE_STATUS_OPTIONS: Array<{
  value: FurnitureStatus;
  label: string;
}> = [
  { value: FURNITURE_STATUS.UNFURNISHED, label: "Não mobiliado" },
  { value: FURNITURE_STATUS.FURNISHED, label: "Mobiliado" },
  { value: FURNITURE_STATUS.SEMI_FURNISHED, label: "Semimobiliado" },
];

export const FURNITURE_STATUS_REQUIRED_MESSAGE = "Informe a mobília do imóvel";

export const FURNITURE_STATUS_INVALID_MESSAGE =
  "O campo mobília deve ser 0 (não mobiliado), 1 (mobiliado) ou 2 (semimobiliado)";

export function isFurnitureStatus(value: unknown): value is FurnitureStatus {
  return (
    value === FURNITURE_STATUS.UNFURNISHED ||
    value === FURNITURE_STATUS.FURNISHED ||
    value === FURNITURE_STATUS.SEMI_FURNISHED
  );
}

export function parseFurnitureStatus(value: unknown): FurnitureStatus {
  if (value === true || value === "true") return FURNITURE_STATUS.FURNISHED;
  if (value === false || value === "false") return FURNITURE_STATUS.UNFURNISHED;

  const numeric = Number(value);
  if (isFurnitureStatus(numeric)) return numeric;

  return FURNITURE_STATUS.UNFURNISHED;
}
